import { render } from "./v-sub-navigation.vue?vue&type=template&id=ed924300&scoped=true"
import script from "./v-sub-navigation.vue?vue&type=script&lang=js"
export * from "./v-sub-navigation.vue?vue&type=script&lang=js"

import "./v-sub-navigation.vue?vue&type=style&index=0&id=ed924300&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed924300"]])

export default __exports__